import React from "react";
import { Link, useLocation } from "react-router-dom";
import { trackCTA } from "@/lib/analytics";

export default function StickyCTA() {
  const location = useLocation();
  if (location.pathname.startsWith("/free-tier-ii-assessment")) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur-md p-3" data-testid="sticky-mobile-cta">
      <Link
        to="/free-tier-ii-assessment"
        onClick={() => trackCTA("Free Assessment", "sticky-mobile")}
        className="block w-full rounded-md bg-amber-500 px-4 py-3 text-center text-base font-bold text-navy-900"
        data-testid="sticky-cta-button"
      >
        Get a Free Tier II Assessment
      </Link>
    </div>
  );
}
